import { useAccessibility } from "../../context/AccessibilityContext"
import { speakOutLoudRichtext, stopSpeechToText } from "../../services/functions"

type BaseHeadlineType = {
    headlineType: 1 | 2 | 3 | 4 | 5 | 6
    label?: string
    classProps?: string
    customColor?: string
}

export default function BaseHeadline(props: BaseHeadlineType) {
    const { readText } = useAccessibility()

    if (!props.label || props.label === undefined || props.label === null || props.label === "") return <></>
    switch (props.headlineType) {
        case 1:
            return (
                <h1
                    onMouseLeave={readText ? () => stopSpeechToText() : () => {}}
                    onMouseEnter={readText ? () => speakOutLoudRichtext(props.label) : () => {}}
                    className={`text-3xl font-headline font-bold ${props.classProps}`}
                    style={{ color: props.customColor }}>
                    {props.label}
                </h1>
            )
        case 2:
            return (
                <h2
                    onMouseLeave={readText ? () => stopSpeechToText() : () => {}}
                    onMouseEnter={readText ? () => speakOutLoudRichtext(props.label) : () => {}}
                    className={`text-3xl font-headline font-bold ${props.classProps}`}
                    style={{ color: props.customColor }}>
                    {props.label}
                </h2>
            )
        case 3:
            return (
                <h3
                    onMouseLeave={readText ? () => stopSpeechToText() : () => {}}
                    onMouseEnter={readText ? () => speakOutLoudRichtext(props.label) : () => {}}
                    className={`text-3xl font-headline font-bold ${props.classProps}`}
                    style={{ color: props.customColor }}>
                    {props.label}
                </h3>
            )
        case 4:
            return (
                <h4
                    onMouseLeave={readText ? () => stopSpeechToText() : () => {}}
                    onMouseEnter={readText ? () => speakOutLoudRichtext(props.label) : () => {}}
                    className={`text-3xl font-headline font-bold ${props.classProps}`}
                    style={{ color: props.customColor }}>
                    {props.label}
                </h4>
            )
        case 5:
            return (
                <h5
                    onMouseLeave={readText ? () => stopSpeechToText() : () => {}}
                    onMouseEnter={readText ? () => speakOutLoudRichtext(props.label) : () => {}}
                    className={`text-3xl font-headline font-bold ${props.classProps}`}
                    style={{ color: props.customColor }}>
                    {props.label}
                </h5>
            )
        case 6:
            return (
                <h6
                    onMouseLeave={readText ? () => stopSpeechToText() : () => {}}
                    onMouseEnter={readText ? () => speakOutLoudRichtext(props.label) : () => {}}
                    className={`text-3xl font-headline font-bold ${props.classProps}`}
                    style={{ color: props.customColor }}>
                    {props.label}
                </h6>
            )
    }
}
